export default "__VITE_ASSET__oM9khpds__"